import * as React from 'react';

import classnames from 'classnames';

import {Button} from '../button/button';

import {FlashBanner} from './flash-banner';

import styles from './retryable-error.module.css';

type Props = {
    message: string;
    details: string | null | undefined;
    retry: () => Promise<any>;
};

export function RetryableError(props: Props) {
    const [showErrorDetails, setShowErrorDetails] = React.useState<boolean>(false);

    const detailsMarkup = showErrorDetails ? (
        <div>{props.details}</div>
    ) : (
        <Button variant='text-secondary' onClick={() => setShowErrorDetails(true)} size='big'>
            Show error details
        </Button>
    );

    return (
        <FlashBanner type='error' leftAlignContent={true} hasBorder={true}>
            <div>
                {props.message}
                <div className={styles['error-actions']}>
                    <div className={classnames('flex', styles['error-details'])}>
                        <Button
                            variant='text-primary'
                            // @ts-expect-error
                            onClick={(e, closeMessage) => {
                                if (closeMessage) {
                                    closeMessage().then(() => {
                                        setShowErrorDetails(false);
                                        props.retry();
                                    });
                                } else {
                                    setShowErrorDetails(false);
                                    props.retry();
                                }
                            }}
                            size='big'
                        >
                            Try again
                        </Button>
                        {props.details ? detailsMarkup : null}
                    </div>
                </div>
            </div>
        </FlashBanner>
    );
}
